import { NavigateWithParams } from '@folio/components/layout/StepperLayout/getRoutesFromStepper';
import { usePolicyOnDashboard } from '@folio/utils/usePolicyOnDashboard';
import type { ReactNode } from 'react';
import { useStopDraft } from './useStopDraft';

type Draft = {
  branchId: string;
  reason: string;
  stopDate?: string;
  requiredDocuments: string[];
  isAwaitingValidation: boolean;
};

/** Steps past the first read the draft, so a deep link without one goes back to step 1. */
export function StopFunnelGuard({
  firstStepPath,
  children,
}: {
  firstStepPath: string;
  children: (draft: Draft) => ReactNode;
}) {
  const { policy } = usePolicyOnDashboard();
  const { draft, isLoading } = useStopDraft(policy.id);

  if (isLoading) {
    return null;
  }

  if (!draft) {
    return <NavigateWithParams to={firstStepPath} />;
  }

  return <>{children(draft)}</>;
}
